import { motion } from "framer-motion";
import { ScrollReveal, StaggerParent, StaggerItem } from "@/components/shared/ScrollReveal";
import { useLang } from "@/i18n/LanguageContext";

const IMAGES = [
  // 0 Publishing — devices editorial (custom)
  `${process.env.PUBLIC_URL}/images/ecosystem/editoria.jpg`,
  // 1 Brand identity — design/branding studio
  `${process.env.PUBLIC_URL}/images/ecosystem/brand.jpg`,
  // 2 Communication — newsroom media wall (custom)
  `${process.env.PUBLIC_URL}/images/ecosystem/comunicazione.jpg`,
  // 3 Personal branding — speaker on stage
  `${process.env.PUBLIC_URL}/images/ecosystem/personal.jpg`,
  // 4 Video & Content — camera interview set (custom)
  `${process.env.PUBLIC_URL}/images/ecosystem/video.jpg`,
  // 5 Special Projects — corporate event (custom)
  `${process.env.PUBLIC_URL}/images/ecosystem/progetti.jpg`,
];

export default function Ecosystem() {
  const { t } = useLang();
  return (
    <section
      id="chi-siamo"
      data-testid="ecosystem-section"
      className="relative bg-black text-white py-28 md:py-40 border-t border-white/10 scroll-mt-20"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16 md:mb-24">
          <ScrollReveal className="lg:col-span-5">
            <p className="font-mono-eyebrow text-[var(--dp-accent)] mb-6">{t.ecosystem.eyebrow}</p>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              {t.ecosystem.title}
            </h2>
          </ScrollReveal>
          <ScrollReveal className="lg:col-span-6 lg:col-start-7" delay={0.15}>
            <p className="text-neutral-300 text-lg md:text-xl leading-relaxed max-w-xl">
              {t.ecosystem.body}
            </p>
          </ScrollReveal>
        </div>

        <StaggerParent className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {t.ecosystem.areas.map((a, i) => (
            <StaggerItem key={i}>
              <motion.article
                data-testid={`ecosystem-area-${i}`}
                whileHover="hover"
                initial="rest"
                animate="rest"
                className="tile-card group p-8 md:p-10 min-h-[440px] flex flex-col justify-between relative overflow-hidden spotlight-parent"
              >
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 + i * 0.12 }}
                  className="absolute inset-0 pointer-events-none"
                >
                  <img
                    src={IMAGES[i % IMAGES.length]}
                    alt=""
                    className="w-full h-full object-cover spotlight-img group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-black/55" />
                </motion.div>

                <div className="relative flex items-start justify-end">
                  <span className="font-mono-eyebrow text-neutral-200">
                    {a.tag}
                  </span>
                </div>

                <div className="relative mt-auto">
                  <h3 className="font-display text-4xl md:text-5xl lg:text-6xl leading-none tracking-tight mb-6 text-white">
                    {a.title}
                  </h3>
                  <p className="text-neutral-200 text-[15px] md:text-base leading-relaxed max-w-md">
                    {a.desc}
                  </p>
                </div>
              </motion.article>
            </StaggerItem>
          ))}
        </StaggerParent>
      </div>
    </section>
  );
}
